import type { ChangesSource, NurseInShift } from "../../../utils/models";

export type DeleteRecurringOrSingleShiftProps = {
	nurseInShift: NurseInShift;
	onCancel: () => void;
	/** `deleted` is whether the removal went through; a failed one also hands over its error (already in a snackbar). */
	onFinished: (deleted: boolean, error?: unknown) => void;
	source: ChangesSource;
	showActual: boolean;
	/** Persist this one scheduled row immediately and let the call-in time stay unknown. */
	applyImmediately?: boolean;
	/**
	 * Whether this entry point may delete a whole recurring series ("make biweekly" / "delete all
	 * recurring") rather than just this one day.
	 *
	 * Opt-out, not opt-in, because every pre-existing caller opens this dialog from the schedule,
	 * where the series is the thing on screen and destroying it from a chosen date forward is in
	 * context. It is off for the Actual view: those rows are one day's worked hours, the menu item
	 * reads "Remove from shift", and the recurring path calls a different endpoint that bypasses the
	 * actual-removal guard entirely — so a stray radio click there would silently wipe out future
	 * schedule. DEFAULT: `true` keeps the two schedule call sites behaving exactly as before.
	 */
	allowRecurringModes?: boolean;
};
export enum DeleteRecurringOrSingleMode {
	DeleteSingle = "Delete Single",
	DeleteBiweeklyDay = "Make Biweekly",
	DeleteRecurring = "Delete Recurring",
}
